import React, {useEffect, useState} from 'react'
import HSALogo from '@/assets/icons/hsa-logo'
import Graph from './Graph'
import {NoExpenseComponent} from './NoExpenseComponent'
import {NoCustomerExpenseComponent} from './NoCustomerExpenseComponent'
import {isEmptyObject} from '@/utils/common'
import {useExpenseSummary} from '@/hooks/expense-dashboard/useExpenseSummary'
import {ExpenseDashboardProps, ExpenseSummary} from './expense-dashboard'

const LEARN_MORE_URL = 'https://hsastore.com/hsa-expense-dashboard.html'
const EXPENSE_DETAILS_URL = 'https://hsastore.com/expense-dashboard'

export const ExpenseDashboard: React.FC<ExpenseDashboardProps> = ({
    userEmail = null,
    hostURL = null
}) => {
    const [graphData, setGraphData] = useState<ExpenseSummary | null>(null)
    const {data, isLoading, error} = useExpenseSummary(userEmail, hostURL)

    useEffect(() => {
        if (!isEmptyObject(data)) {
            setGraphData(data ?? null)
        }
    }, [data])

    const {isCustomerExists, expenseTotal} = graphData || {}

    return (
        graphData && (
            <div className="p-5">
                <div className="border border-black p-5 w-full">
                    <div className="flex items-center">
                        <div className="flex-[0_0_90px] max-w-[90px] mr-[10px] relative top-[-2px]">
                            <HSALogo data-testid={'ExpenseDashboard-HSALogo'} />
                        </div>
                        <h4 className="font-grotesque-medium font-bold text-xs sm:text-sm lg:text-xl">
                            HSA Expense Dashboard
                        </h4>
                    </div>
                    {!isCustomerExists ? (
                        <NoCustomerExpenseComponent
                            learnMoreUrl={LEARN_MORE_URL}
                            expenseDetailUrl={EXPENSE_DETAILS_URL}
                            data-testid={'ExpenseGraph-NoCustomerExpenseComponent'}
                        />
                    ) : expenseTotal === 0 ? (
                        <NoExpenseComponent
                            data={graphData}
                            learnMoreUrl={LEARN_MORE_URL}
                            data-testid={'ExpenseGraph-NoExpenseComponent'}
                        />
                    ) : (
                        <Graph noReciepts={false} data={graphData} data-testid={'ExpenseGraph'} />
                    )}
                </div>
            </div>
        )
    )
}
